import React from 'react';
import { connect } from 'react-redux';

import BaseLayoutPromo from 'apps/promo/components/common/BaseLayoutPromo';
import { PromoInfoPage } from 'apps/promo/components/common/PromoInfoPage/PromoInfoPage';
import BasePageForNoAuth from 'apps/promo/components/utils/BasePageForNoAuth';
import { DL_EMAIL_CONFIRM_REDIRECT } from 'apps/promo/constants/UrlConstants';

const EmailConfirm = (props) => {
    return (
        <BaseLayoutPromo>
            <PromoInfoPage
                animatedIconSuccess={props.confirm}
                animatedIconFail={!props.confirm}
                headerText={props.confirm ? props.emailConfirmSuccessText : props.emailNotConfirmText}
                primaryButtonType="link"
                primaryButtonCaption={props.continueButton}
                primaryButtonLink={DL_EMAIL_CONFIRM_REDIRECT}
            />
        </BaseLayoutPromo>
    );
};
const mapStateToProps = (state) => {
    return {
        emailConfirmSuccessText: state.messages.pageMessages.emailConfirmSuccessText,
        continueButton: state.messages.pageMessages.continueButton,
        emailNotConfirmText: state.messages.pageMessages.emailNotConfirmText,
        confirm: state.extra.confirm,
        authUser: state.auth.authUser,
        lang: state.language.lang,
        country: state.app.country,
    };
};
export default connect(mapStateToProps)(BasePageForNoAuth(EmailConfirm));
